module.exports = __webpack_public_path__ + "static/img/rights.d474f23e.png";